import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';




/*
Usage: 

<WhateverComponent
className={cn(baseClassName, className of whatever component, 
  {nameOfClass: conditional}
 )}


 twMerge -  util fn to efficiently merge Tailwind CSS classes in JS without style conflicts
 https://www.npmjs.com/package/tailwind-merge
 clsx - utility for constructing classNames strings conditionally
https://www.npmjs.com/package/clsx


Why?: Pass in conditionals to clsx and wrap it with twMerge for cn

*/
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

